<div [id]="id" class="ignite-snackbar">
  <div class="ignite-snackbar-message">
    <div class="ignite-snackbar-desktop">
      @if (snackbarType === igniteSnackbarType.Success) {
        <i class="fal fa-check-circle success"></i>
      }
      @if (snackbarType === igniteSnackbarType.Alert) {
        <i class="fal fa-exclamation-circle alert"></i>
      }
      @if (snackbarType === igniteSnackbarType.Info) {
        <i class="fal fa-info-circle"></i>
      }
    </div>
    <div class="message-text">{{ message }}</div>
  </div>
  <div class="ignite-snackbar-action">
    @if (action !== '') {
      <button type="button" mat-button class="ignite-snackbar-desktop" (click)="onAction($event)">
        <span class="action-text"> {{ action }} </span>
      </button>
    }
    <button type="button" mat-button (click)="dismiss($event)">
      <span class="action-text"> DISMISS </span>
    </button>
  </div>
</div>
